<script lang="ts" setup>

// Idioma
const { t } = useI18n()

// Propuesta de valor (traducida)
const heroBenefits = [
  { icon: 'calendar-days', labelKey: 'labels.hero.entradaFlexible' },
  { icon: 'shield-check', labelKey: 'labels.hero.hotelesVerificados' },
  { icon: 'moon', labelKey: 'labels.hero.sinNocheMinima' }
]

// Props
const props = defineProps({
  titulo: String,
  subtitulo: String
})

// Scroll Store
const scroll = useScrollStore()
const { isScrolledInput } = storeToRefs(scroll)

const [tituloPart1, tituloPart2] = props?.titulo?.split(' ') ?? []

</script>

<template>

  <div class="flex flex-col w-full justify-center gap-4 z-10">

    <!-- Desktop: sección a ancho completo del contenedor (sin 100vw, sin márgenes negativos) -->
    <div class="hidden md:flex md:relative md:w-full h-full pt-40 pb-24 lg:pt-48 lg:pb-32 md:flex-col md:-mt-16">
      <div class="absolute inset-0 z-0">
        <NuxtImg src="/home/background.webp" provider="s3Provider" preload width="1920" height="600" format="webp"
          alt="Fondo cama hotel" class="w-full h-full object-cover" />
        <div class="absolute inset-0 bg-black/25" aria-hidden="true" />
      </div>
      <div class="relative z-10 flex flex-col items-center pb-8 px-4 mx-auto w-full">
        <div class="text-center  max-w-2xl p-4 pt-0 pb-6">
          <h1 class="text-6xl text-white drop-shadow-lg md:text-8xl pb-2 text-wrap">
            <span class="block md:inline md:mr-8">{{ tituloPart1 }}</span>
            <span class="block md:inline">{{ tituloPart2 }}</span>
          </h1>
          <p class="text-md md:text-xl text-white pb-1 drop-shadow">{{ subtitulo }}</p>
        </div>
        <div v-show="!isScrolledInput" class="w-full max-w-3xl px-4">
          <SearchInput is-hero />
        </div>
      </div>
      <div class="flex justify-center z-10 gap-12">
        <div v-for="item in heroBenefits" :key="item.labelKey"
          class="flex items-center gap-1.5 text-gray-50 bg-white/10 backdrop-blur-lg border border-gray-200/30 rounded-full p-2 px-4">
          <UIcon :name="`i-heroicons-${item.icon}`" class="size-5" />
          <span class="text-sm font-medium">{{ t(item.labelKey) }}</span>
        </div>
      </div>

    </div>

    <!-- Mobile: layout actual sin cambios -->
    <div class="relative w-full bg-[#b9b19f]/75 md:hidden max-w-5xl mx-auto -mt-16 pt-16">
      <div class="absolute h-full w-full top-0">
        <NuxtImg src="/home/background.webp" provider="s3Provider" preload width="400" height="500" format="webp"
          alt="Fondo cama hotel" class="w-full h-full object-cover" />
      </div>
      <div class="flex flex-col relative m-5 shadow border border-neutral-100/30 pt-2 rounded-3xl backdrop-blur-sm">
        <div class="absolute inset-0 bg-linear-to-b from-black/15 to-white/25 rounded-3xl" aria-hidden="true" />
        <div class="text-center p-4 pt-2 pb-0 relative">
          <h1 class="text-7xl text-white drop-shadow md:text-9xl lg:text-[10rem] pb-2 text-wrap">
            <span class="block md:inline md:mr-8">{{ tituloPart1 }}</span>
            <span class="block md:inline">{{ tituloPart2 }}</span>
          </h1>
          <p class="text-md md:text-xl pb-1 text-white drop-shadow">{{ subtitulo }}</p>
        </div>
        <div v-show="!isScrolledInput" class="p-3 relative">
          <SearchInput is-hero />
        </div>
        <div class="flex items-center justify-between z-10 gap-4 p-4 pt-0">
          <div v-for="item in heroBenefits" :key="item.labelKey"
            class="flex flex-col items-center gap-1 text-gray-50 p-0.5 px-2 pr-3">
            <UIcon :name="`i-heroicons-${item.icon}`" class="size-4" />
            <span class="text-center text-[10px] font-medium leading-3">{{ t(item.labelKey) }}</span>
          </div>
        </div>
        <div v-if="isScrolledInput" class="h-48" />
      </div>
    </div>

    <!-- Espaciador cuando el input hace scroll (solo desktop) -->
    <div v-if="isScrolledInput" class="hidden md:block h-6" />
  </div>
</template>